import { formatDate, subHours } from "@/lib/time";

/** A template's sale lead time is prefilled into the visible selling start, so
 *  the partner sees and can adjust what the šablona chose (ADR 0007). With no
 *  lead time the field stays empty and the API's `src/sale-window.ts` default
 *  decides; the copy beside the field names that default in words, never by
 *  computing a bound the API owns. */
export function templateSaleStartValue(
  day: Date,
  startTime: string,
  leadTimeHours: number | null,
): string {
  if (leadTimeHours === null || !startTime) return "";
  const startsAt = new Date(`${formatDate(day, "yyyy-MM-dd")}T${startTime}:00`);
  return formatDate(subHours(startsAt, leadTimeHours), "yyyy-MM-dd'T'HH:mm");
}
